import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Main title component.
 */
@Component({
  selector: 'caixa-webcomponent-main-title',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './main-title.component.html',
  styleUrl: './main-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainTitleComponent {
  /**
   * Title text.
   */
  @Input()
  public text = '';

  /**
   * Timestamp of the last data refresh, rendered above the OPF disclaimer
   * when provided.
   */
  @Input()
  public lastUpdate: Date | number | string | null = null;

  /**
   * Regulatory disclaimer about Open Finance data, required by Caixa on every
   * interface that displays OPF data.
   */
  public readonly opfDisclaimer =
    'Dados fornecidos pelas instituições financeiras via Open Finance. '
    + 'O Meu CAIXA apresenta as informações recebidas, sujeitas a atualização '
    + 'ou correção pela instituição de origem.';
}
